import { useStatusPerks } from '@bonanza-social/status';
import { selectStatus } from '@bonanza-social/status/state';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectSlots } from '../state/slots/slots.slice';

const usePromotion = () => {
  const slots = useSelector(selectSlots);
  const status = useSelector(selectStatus);
  const { shopPromotionValue } = useStatusPerks();

  if (
    !shopPromotionValue ||
    !slots.length ||
    !status ||
    status.playerStatus === 'Member'
  ) {
    return;
  }

  return {
    slots,
    playerStatus: status.playerStatus,
    shopPromotionValue,
  };
};

export default usePromotion;
